import { VueCookieNext } from "vue-cookie-next";
import store from "../store/index";
import { environment } from "./APointAPI"
import { __ } from "../plugins/i18n/index";
export function csvToObjArray(csv, spliter = ",") {
    //parse csv to object
    // console.log("csv", csv);
    let ar = [];
    if (csv === undefined || csv === "" || csv === null) return ar;
    ar = csv.split(spliter);
    return ar.map((val, index) => {
        return { key: index, value: val };
    });
    // console.log("res", res);
}

export function arrayToCsv(a, seperator = ",") {
    //convert array of items to csv string
    return a.join(seperator);
}

export function dateStr(
    today,
    yrDigits = 4,
    withTime = false,
    withSeconds = false
) {
    if (typeof today === "undefined") {
        today = new Date();
    } else {
        if (typeof today === "string") today = new Date(today);
    }
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;

    let mm = today.getMonth() + 1;
    if (mm < 10) mm = "0" + mm;
    let yy = today.getFullYear() - (yrDigits === 2 ? 2000 : 0);
    today = dd + "/" + mm + "/" + yy;
    if (withTime) {
        let hh = today.getHours();
        if (hh < 10) hh = "0" + hh;

        let nn = today.getMinutes();
        if (nn < 10) nn = "0" + nn;
        today += ` ${hh}:${mm}`;
        if (withSeconds) {
            let ss = today.getSeconds();
            if (ss < 10) ss = "0" + ss;
            today += `:${ss}`;
        }
    }
    return today;
}

export function getFileExtension(fileName) {
    let x = 0;
    x = fileName.lastIndexOf(".");
    if (x == 0) {
        return "";
    } else {
        return fileName.substring(x + 1, fileName.length).toUpperCase();
    }
}

export function dateFormat(
    date,
    withTime = false,
    withSeconds = false,
    yrTwoDigits = false
) {
    let dateOption = {
        month: "2-digit",
        day: "2-digit",
    };

    if (yrTwoDigits) dateOption.year = "2-digit";
    else dateOption.year = "numeric";

    if (withTime) {
        dateOption.hour = "2-digit";
        dateOption.hour12 = false;
        dateOption.minute = "2-digit";
        if (withSeconds) dateOption.second = "2-digit";
    }

    if (date === undefined) {
        date = new Date();
    } else {
        if (typeof date === "string") date = new Date(date);
    }

    let formated = new Intl.DateTimeFormat("en-GB", dateOption).format(date);

    return formated.replace(",", "");
}

export function resizeImage(image, max_width, quality) {
    const fileName = image.name;
    const reader = new FileReader();
    reader.readAsDataURL(image);
    return new Promise((resolve) => {
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            resolve(
                new Promise((resolve, reject) => {
                    (img.onload = () => {
                        const elem = document.createElement("canvas");
                        const width = Math.min(max_width, img.width);
                        const scaleFactor = width / img.width;
                        elem.width = width;
                        elem.height = img.height * scaleFactor;

                        const ctx = elem.getContext("2d");
                        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
                        ctx.canvas.toBlob(
                            (blob) => {
                                const file = new File([blob], fileName, {
                                    type: image.type,
                                    lastModified: Date.now(),
                                });

                                resolve(file);
                            },
                            image.type,
                            quality
                        );
                    }),
                        (reader.onerror = (error) => reject("Error:", error));
                })
            );
        };
    });
}

export function alertSuccess(summaryText, detailText, _this) {
    // console.log("alertSuccess");
    _this.$toast.add({
        severity: "success",
        summary: summaryText,
        detail: detailText,
        life: 3000,
    });
}

export function OneSignalInit(externalUserId) {
    let lastSignPush = new Date(VueCookieNext.getCookie("LastSignPush"));
    let d = new Date();
    d.setMonth(d.getMonth() - 1);
    if (d.getTime() > lastSignPush.getTime()) {
        if (window.cordova.platformId !== "browser") {
            //   # https://documentation.onesignal.com/docs/cordova-sdk-setup#set-external-user-id
            // TODO:add registraition to apoint
            // NOTE: Update the setAppId value below with your OneSignal AppId.
            window.plugins.OneSignal.setAppId(process.env.VUE_APP_OneSignal_AppID);
            window.plugins.OneSignal.setNotificationOpenedHandler(function (jsonData) {
                console.log("notificationOpenedCallback: " + JSON.stringify(jsonData));
            });
            window.plugins.OneSignal.setExternalUserId(externalUserId);

            // iOS - Prompts the user for notification permissions.
            //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
            window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(
                function (accepted) {
                    console.log("User accepted notifications: " + accepted);
                }
            );
        } else {
            console.log("initBrowser");
            const EL = document.createElement("script");
            EL.src = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
            EL.async = "";
            document.head.appendChild(EL);

            setTimeout(() => {
                window.OneSignal = window.OneSignal || [];
                window.OneSignal.registerForPushNotifications()
                window.OneSignal.push(function () {
                    window.OneSignal.init({
                        appId: process.env.VUE_APP_OneSignal_AppID,
                        allowLocalhostAsSecureOrigin: true,
                        notifyButton: {
                            enable: true,
                        },
                    });
                    window.OneSignal.setExternalUserId(externalUserId);
                });
            }, 3000);
        }
        VueCookieNext.setCookie("LastSignPush", new Date());
    }
}

export function isValidEmail(email) {
    return /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)
}

export function isValidPhoneNumber(phoneNumber) {
    return /[0-9]{10}$/.test(phoneNumber)
}

export function errorReceived(summaryText, error, detailText = undefined) {
    store.dispatch("doLoading", false);
    if (error && environment === "Development") console.log(summaryText, error);
    if (detailText === undefined) detailText = __('An error occurred');
    store.commit("setGeneralErrorToast", { visible: true, summaryText: summaryText, detailText: detailText });
}

export function isRTL(s) {
    try {
        var ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF',
            rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC',
            rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

        return rtlDirCheck.test(s);
    } catch {
        //
    }
}

export function isRussian(text) {
    return /^[а-яА-ЯЁё 0-9./<>{}()!@#$%^&*,;?:]/.test(text);
}

export function isEnglish(text) {
    return /^[a-zA-Z 0-9./<>{}()!@#$%^&*,;?:]+$/.test(text);
}

export function sort_by(field, reverse, primer) {

    const key = primer ?
        function (x) {
            return primer(x[field])
        } :
        function (x) {
            return x[field]
        };

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    }
}

export function sort_array_by_field(array, field, reverse, primer) {
    array.sort(
        sort_by(field, reverse, primer)
    );
}

export function showSuccessOrFailedModal(message, isSuccess = true, timeout = 2000, showCloseBtn = true) {
    store.commit("setGeneralSuccessOrFailedModal", {
        visible: true,
        isSuccess: isSuccess,
        message: message,
        timeout: timeout,
        showCloseBtn: showCloseBtn
    });
}

export function formatDate(value) {
    if (!value) return ''
    let date = new Date(value)
    if (date == 'Invalid Date') return value
    return date.toLocaleDateString('en-GB')
  }